import { mainNum } from '../constants'

const threeRatio = 3
const fourRatio = 4
const threeToFourRatio = threeRatio / fourRatio
const oneToOneRatio = 1 / 1

const validates = {
    images: {
        name: 'images',
        validate: {
            name: '1:1主图',
            validatorNum: mainNum,
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif', 'image/webp', 'image/bmp']
            },
            ratioValidator: {
                ratio: oneToOneRatio
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 3
            },
            rectValidator: {
                maxWidth: 5000,
                maxHeight: 5000
            }
        }
    },
    threeToFourImages: {
        name: 'threeToFourImages',
        validate: {
            name: '3:4主图',
            validatorNum: 5,
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif', 'image/webp', 'image/bmp']
            },
            rectValidator: {
                minWidth: 750,
                minHeight: 1000,
                maxWidth: 5000,
                maxHeight: 5000
            },
            ratioValidator: {
                ratio: threeToFourRatio,
                ratioDiffScope: 0.001
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 3
            }
        }
    },
    goodsSku: {
        name: 'goodsSku',
        validate: {
            name: '颜色图',
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif', 'image/webp', 'image/bmp']
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 3
            },
            rectValidator: {
                maxWidth: 5000,
                maxHeight: 5000
            }
        }
    },
    verticalImage: {
        name: 'verticalImage',
        validate: {
            name: '宝贝长图',
            imageTypeValidator: {
                noAcceptTypeList: ['image/gif', 'image/webp', 'image/bmp']
            },
            rectValidator: {
                minWidth: 480,
                minHeight: 720
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 3
            },
            ratioValidator: {
                // eslint-disable-next-line no-magic-numbers
                ratio: 2 / 3,
                ratioDiffScope: 0.001
            }
        }
    },
    desc_old: {
        name: 'desc_old',
        validate: {
            rectValidator: {
                maxWidth: 10000,
                maxHeight: 10000
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 20
            }
        }
    },
    wirelessDesc_old: {
        name: 'wirelessDesc_old',
        validate: {
            rectValidator: {
                maxWidth: 10000,
                maxHeight: 10000
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 20
            }
        }
    },
    wirelessDesc: {
        name: 'wirelessDesc',
        validate: {
            rectValidator: {
                maxWidth: 10000,
                maxHeight: 10000
            },
            sizeValidator: {
                minSize: 0,
                maxSize: 20
            }
        }
    }
}

// 给铺货模版的配置
export const goodsQuickSets = [validates.images, validates.threeToFourImages, validates.verticalImage]

// 商品主图、3:4主图、
export default validates
